export const opportunities = [
  {
    title: "All",
    type: "",
  },
  {
    title: "Company",
    type: "diverse_company",
  },
  {
    title: "Capital/Funding",
    type: "funding",
  },
  {
    title: "Projects",
    type: "project",
  },
  {
    title: "Board of Directors",
    type: "board_of_directors",
  },
  {
    title: "Careers-Executive",
    type: "careers_executive",
  },
  {
    title: "Careers-Professional",
    type: "careers_professional",
  },
  {
    title: "Mentors",
    type: "mentoring",
  },

  {
    title: "Sponsors",
    type: "sponsorship",
  },
]
